interface Props {
  stats?: {
    totalConversations?: number;
    unread?: number;
    avgResponseTime?: string;
    resolvedToday?: number;
  };
}

export default function WhatsAppStatsBar({ stats: incomingStats }: Props) {
  const stats = [
    {
      label: "Total Conversations",
      value: incomingStats?.totalConversations ?? 0,
      icon: "ri-message-3-line",
      iconBg: "bg-green-100",
      iconColor: "text-green-600",
    },
    {
      label: "Unread",
      value: incomingStats?.unread ?? 0,
      icon: "ri-notification-3-line",
      iconBg: "bg-red-100",
      iconColor: "text-red-600",
      badge: (incomingStats?.unread ?? 0) > 0,
    },
    {
      label: "Avg Response Time",
      value: incomingStats?.avgResponseTime ?? "2.4m",
      icon: "ri-timer-line",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-600",
    },
    {
      label: "Resolved Today",
      value: incomingStats?.resolvedToday ?? 0,
      icon: "ri-check-double-line",
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 px-5 py-4">
      {stats.map((s) => (
        <div
          key={s.label}
          className="bg-white rounded-xl border border-[#e5e7eb] px-4 py-3 flex items-center gap-3"
        >
          <div className={`w-9 h-9 rounded-lg ${s.iconBg} flex items-center justify-center flex-shrink-0`}>
            <i className={`${s.icon} ${s.iconColor} text-base`} />
          </div>
          <div className="min-w-0">
            <p className="text-xs text-[#6b7280] whitespace-nowrap">{s.label}</p>
            <p className="text-lg font-bold text-[#111827]">
              {s.value}
              {s.badge && (
                <span className="ml-1.5 inline-block w-2 h-2 rounded-full bg-red-500 align-middle" />
              )}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}